var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#09B4B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.1,189.6c-18.6-15.7-47.2-13.8-63.4,5.5l-9.7,11.5l68.9,57.8l9.3-11.5C517.2,234,515.2,205.6,496.1,189.6 z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.4,350.5l-5.1,6.1c-4.5,5.3-7.7,11.7-9.3,18.5L273,433.4c-1.3,5.5,0.6,11.3,5,15 c4.2,3.6,10.2,4.6,15.6,2.3l55.1-23.9c6.4-2.8,12.1-7,16.5-12.3l5.1-6.1L301.4,350.5z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "403.7,229.5 320.7,327.6 389.7,385.5 472.6,287.4  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376,66.5l-57-54.1c-5.4-5.1-12-8.1-19-10.1V90h89.1C387.2,81.1,382.7,72.8,376,66.5z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.8,368.1c2.7-11.2,8-21.8,15.4-30.7L390,199.2V120H285c-8.3,0-15-6.7-15-15V0H45C20.2,0,0,20.2,0,45v422 c0,24.8,20.2,45,45,45h300c24.8,0,45-20.2,45-45v-35.5l-1.9,2.3c-7.4,8.8-16.9,15.9-27.5,20.5l-55.1,23.9 c-15.5,6.7-33.5,4.3-46.8-6.8c-13.1-11-18.8-28.2-14.9-44.9L257.8,368.1z M75,90h150c8.3,0,15,6.7,15,15s-6.7,15-15,15H75 c-8.3,0-15-6.7-15-15S66.7,90,75,90z M75,181h240c8.3,0,15,6.7,15,15s-6.7,15-15,15H75c-8.3,0-15-6.7-15-15S66.7,181,75,181z  M195,391H75c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15h120c8.3,0,15,6.7,15,15S203.3,391,195,391z M75,301c-8.3,0-15-6.7-15-15 c0-8.3,6.7-15,15-15h180c8.3,0,15,6.7,15,15c0,8.3-6.7,15-15,15H75z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionHistory);
export default __webpack_public_path__ + "static/media/TransactionHistory.d96d3404ed352b01c489d72c105cd8a5.svg";
export { ForwardRef as ReactComponent };